/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FORM_DATA = [
    {
        label: "Name*",
        name: "name",
        type: "text-input",
        fieldProps: {}
    },
        {
        label: "Email*",
        name: "email",
        type: "text-input",
        fieldProps: {}
    },
    {
        label: "Select Persona*",
        name: "persona",
        type: "async-select",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                // {
                //     value: "klefki",
                //     label: "Klefki"
                // },
                // {
                //     value: "trag",
                //     label: "Trag"
                // },
                // {
                //     value: "collectible",
                //     label: "Collectible"
                // }
            ]
        }
    },
    // {
    //     label: "Invite User",
    //     name: "inviteUser",
    //     type: "checkbox",
    //     fieldProps: {
    //         values: [
    //             {
    //                 label: "Invite",
    //                 value: "invite"
    //             },
           
    //         ]
    //     }
    // },

]

export const FIELDS: any ={
    name: {
        validators: {
            notEmpty: {
                message: "The Given Name is required"
            },

            regexp: {
                regexp: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                message:
                    "The Given Name  can only consist of alphabeticals,"
            }
        }
    },



    email: {
        validators: {
            notEmpty: {
                message: "The Email is required"
            },
            regexp: {
                regexp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message:
                    "Please enter valid email address"
                    
            }
        }
    },

    persona: {
        validators: {
            notEmpty: {
                message: "Persona must be selected"
            },
           
        }
    },
}